import { Button, Col, Collapse, DatePicker, Radio, Row, Select, Spin, Switch, Tooltip, Card, Form, Checkbox, RangePicker, Input, Space, Option } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { generateBlob } from "../../Utils/CreateBlob";
import { errHandler } from "../../helper/helper";
// import './Loan.css';
import '../../Layout/cardStyle.css';
import {
    generateActiveAndDormantWasamWise,
    generateBranchLoanReport,
    generateDistrictLoanProductReport,
    generateDistrictLoanReport,
    generateDistrictReport,
    generateLoanDisposeSummaryReport,
    generateLoanReportForDay,
    generateLoanSummaryReportforDistrict,
    generateLoanSummaryReports,
    getAllLoans,
    getDistrictBranches,
    getDivAreaBranches,
    generateDisbursementAmountReportB,
    generateTrailBalanceByDate,
    generateLoanPendingInstallment,
    generateLoanCertificate,
    generateLoanDisbursementSummaryReport,
    getLoanPaymentHistory

} from "./LoanService";
import { getDistrictDivisionalBranchDetails } from "../Savings/SavingService";
import { disabledDate, disabledDatesBeforeYear } from "../../Utils/Util";
import jwt_decode from "jwt-decode";
import { getAllWasamsByBranchId } from "../Savings/SavingService";
import { getAllBranchesByDistrictName } from "../GeneralLedger/GeneralLedgerService";
import CustomFooter from "../../Layout/CustomFooter";
import LoanSummaryForDay from "./LoanSummaryForDay";
import LoanTrailBalance from "./LoanTrailBalance";
import generateLoanDisbursementSummaryExcel from "../../Utils/LoanDisbursementSummaryExcel";
import LoanSummary from "./LoanSummary";
import LoanPaymentHistory from "./LoanPaymentHistory";
import PermissionPanel from "../../Layout/PermissionPanel";
import DistrictLoanWiseReport from "./DistrictWiseLoanReport";
import generateLoanAmountExcel from "../../Utils/Loan/LoanAmountExcel";
import { dataCellStyle, headerStyle, totalStyle } from "../../Utils/excelStyle";
import loanPendingInstallmentExcel from "../../Utils/Loan/LoanPendingInstallmentExcel";
import BranchLocationSelector from "../BranchLocationSelector";
import DistrictWiseDisposeSummary from "./DistrictWiseDisposeSummary";
import LoanApplicationProcess from "./LoanApplicationProcess";
import CustomerLoanDetails from "./CustomerLoanDetails";
import WasamaCustomerLoanDetails from "./WasamaCustomerLoanDetails";
import LoanProgressReport from "./LoanProgressReport";


const createDistrictData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            districtId: post.districtId,
            districtName: post.districtName,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }

    }))
    return convertedData;
};

const createDivAreaData = (data) => {
    return (data.map((post) => {
        return {
            divAId: post.divAId,
            divAIdCode: post.divAIdCode,
            divAIdName: post.divAIdName,
            districtId: post.districtId,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }
    }));
};

const createWasamData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            wastId: post.wastId,
            wasCode: post.wasCode,
            wasName: post.wasName
        }
    }))
    return convertedData;
};
const createdBranchData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            id: post.id,
            branchCode: post.branchCode,
            branchName: post.branchName,
            branchNumber: post.branchNumber,
            locked: post.locked,
            divisionalAreaId: post.divisionaAreaId,
        }

    }))
    return convertedData;
};

const createDepositsProductData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            productId: post.productId,
            productCode: post.productCode,
            productName: post.productName
        }
    }))
    return convertedData;
};
// const handleRangeDateChange = (dates, dateStrings) => {
//     if (dates) {
//         setSelectedDateRange(dates);
//     } else {
//         setSelectedDateRange([]);
//     }
// };
const Loan = () => {

    const [loading, setLoading] = useState(false);
    const [loadingbranch, setLoadingbranch] = useState(false);
    const [loadingDisposeSummary, setLoadingDisposeSummary] = useState(false);
    const [loadingSummaryReport, setLoadingSummaryReport] = useState(false);
    const [dateLoading, setDateLoading] = useState(false);
    const [dateLoadingProductWise, setDateLoadingProductWise] = useState(false);
    const [date, setDate] = useState(null);
    const [districtData, setDistrictData] = useState([]);
    const [divAreaData, setDivAreaData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [districtRadio, setDistrictRadio] = useState(null);
    const [branchRadio, setBranchRadio] = useState(0);
    const [selectedDivisionalArea, setSelectedDivisionalArea] = useState(null);
    const [selectedProductLoanDistrict, setSelectedProductLoanDistrict] = useState(null);
    const [isOnDistrict, setIsOnDistrict] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedBranchForDisbursement, setSelectedBranchForDisbursement] = useState("");
    const [loanLoading, setLoanLoading] = useState(false);
    const [loanNo, setLoanNo] = useState("");
    const [districtLoading, setDistrictLoading] = useState(false);
    const [branchDate, setBranchDate] = useState(null);
    const [districtDate, setDistrictDate] = useState(null);
    const [loanTrailBalanceDate, setLoanTrailBalanceDate] = useState(null);
    const [isExcelLoanReport, setIsExcelLoanReport] = useState(false);
    const [isExcelLoanAmtReport, setIsExcelLoanAmtReport] = useState(false);
    const [isExcelDisposeSummary, setIsExcelDisposeSummary] = useState(false);
    const [isExcelProductLoan, setIsExcelProductLoan] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedDatesForDisposeSummary, setSelectedDatesForDisposeSummary] = useState([]);
    const [selectedDistrictForLoanDisposeSummary, setSelectedDistrictForLoanDisposeSummary] = useState([]);
    const [selectedDistrictForDisposeSummary, setSelectedDistrictForDisposeSummary] = useState(null);
    const [isExcelBranchLoan, setIsExcelBranchLoan] = useState(false);
    const [isExcelBranchSummary, setIsExcelBranchSummary] = useState(false);
    const [isExcelLoanSummary, setIsExcelLoanSummary] = useState(false);
    const [isExcelDistrictLoan, setIsExcelDistrictLoan] = useState(false);
    const [branchData, setBranchData] = useState([]);
    const [selectedDistrictData, setSelectedDistrictData] = useState(null);
    const [showRangePicker, setShowRangePicker] = useState(false);
    const [mincount, setmincount] = useState("");
    const [maxcount, setmaxcount] = useState("");
    const [ShowMinMax, setShowMinMax] = useState(false);
    const [selectedDateRange, setSelectedDateRange] = useState([]); // Declare the state
    const [selectedWasamLoanTrialBalance, setSelectedWasamLoanTrialBalance] = useState(null);
    const [selectedWasamLoanPendingInstallment, setSelectedWasamLoanPendingInstallment] = useState([]);
    const [LoanCertificateDate, setLoanCertificateDate] = useState(null); // State for saving certificate date
    const [selectedLoanCertificateProduct, setSelectedLoanCertificateProduct] = useState(null);
    const [loanCertificateWasam, setLoanCertificateWasm] = useState(null);
    const [selectedDistrictForDisbursement, setSelectedDistrictForDisbursement] = useState(null);
    const [selectedDivAreasForDisbursement, setSelectedDivAreasForDisbursement] = useState([]);
    const [filteredDivAreasForDisbursement, setFilteredDivAreasForDisbursement] = useState([]);
    const [filteredBranchesForDisbursement, setFilteredBranchesForDisbursement] = useState([]);
    const [selectedBranchesForDisbursement, setSelectedBranchesForDisbursement] = useState([]);

    const handleMinChange = (e) => {
        const value = Number(e.target.value);
        // Set MinValue to at least 0
        setmincount(value < 0 ? 0 : value);
    };

    const handleWasamChangeLoanCertificate = (value) => {
        setLoanCertificateWasm(value)
    }

    const handleMaxChange = (e) => {
        const value = Number(e.target.value);
        // Set MaxValue to at most 500
        setmaxcount(value > 500 ? 500 : value);
    };

    const disabledDatesBeforeYear = current => {
        const currentDate = new Date();
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(currentDate.getFullYear() - 5);

        return current && (current > currentDate || current < oneYearAgo);
    };
    const { Panel } = Collapse;
    const { Option } = Select;

    const { RangePicker } = DatePicker;

    const handleRangeDateCheckboxChange = (e) => {
        setSelectedDateRange([]);


        setShowRangePicker(e.target.checked);


    };

    const handleRangeDateChange = (dates, dateStrings) => {
        if (dates) {
            setSelectedDateRange(dates); // Store the actual date objects in the state
        } else {
            setSelectedDateRange([]); // Reset if no dates are selected
        }
    };


    const handleMinMaxCheckboxChange = (e) => {
        setmincount("");
        setmaxcount("");
        setShowMinMax(e.target.checked);
    };

    const [selectedWasam, setSelectedWasam] = useState([]);

    const branchId = localStorage.getItem("branchId");
    const loginPlaceId = localStorage.getItem("placeId");
    const token = localStorage.getItem("accessToken");
    const decodeToken = token ? jwt_decode(token) : null;



    const districtName = loginPlaceId === "4" ? decodeToken.districtName : null;
    const divisionalID = loginPlaceId === "2" ? decodeToken.divAId : " ";

    const [wasamData, setWasamData] = useState([]);

    const [selectedWasamWiseProduct, setSelectedWasamWiseProduct] = useState([]);
    // chenuka
    const [selectedTrailBalanceProduct, setSelectedTrailBalanceProduct] = useState(null);
    // chenuka
    const [selectedLoanProduct, setSelectedLoanProduct] = useState([]);

    const [selectedLoanProductForDisposeSummary, setSelectedLoanProductForDisposeSummary] = useState(null);

    const [loanProducts, setLoanProducts] = useState([]);

    const [productAndWasamWiseLoading, setProductAndWasamWiseLoading] = useState(false);
    // chenuka
    const [trailBalanceByDateLoading, setTrailBalanceByDateLoading] = useState(false);
    // chenuka

    // const [otherDistrictDate, setOtherDistrictDate] = useState(false);
    const [LoanPendingInstallment, setLoanPendingInstallemnt] = useState(false);
    const [LoanCertificate, setLoanCertificate] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const [selecteddisbursementamountProduct, setselecteddisbursementamountProduct] = useState([]);

    const [productDisbursementLoading, setproductDisbursementLoading] = useState(false);

    const [selectedDaDates, setselectedDaDates] = useState(null);

    const [districtDivisionalBranchData, setDistrictDivisionalBranchData] = useState([]);

    const [locationData, setLocationData] = useState({});



    const getAllBranchesbyDistrict = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrictData : decodeToken.districtName;
        getAllBranchesByDistrictName(districtName).then((res => {
            let data = createdBranchData(res.data);
            setBranchData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };



    const getAllWasam = () => {
        let branchId = decodeToken.branchId ? decodeToken.branchId : " ";
        console.log(branchId)
        getAllWasamsByBranchId(branchId).then((res) => {
            let data = createWasamData(res.data);
            setWasamData(data);
        }).catch((err) => {
            errHandler(err);
        })
    }
    const handleDistrictRadioChange = (e) => {
        if (e.target.value === 1) {
            setSelectedDistrict(null);
        }
        setDistrictRadio(e.target.value);
    };
    const onRadioChange = (e) => {
        setBranchRadio(e.target.value);
    };

    const handleDateChange = (dates) => {
        setSelectedDates(dates);
    };
    const handleDaDateChange1 = (dates) => {
        setSelectedDates(dates);
    };

    const handleDateChangeForDisposeSummary = (dates) => {
        setSelectedDatesForDisposeSummary(dates);
    };

    const onSwitchChangeLoan = (checked) => {
        setIsExcelLoanReport(checked);
    };
    const onSwitchChangeLoanAmt = (checked) => {
        setIsExcelLoanAmtReport(checked);
    };

    const onSwitchChangeDisposeSummary = (checked) => {
        setIsExcelDisposeSummary(checked);
    }

    const onSwitchChangeProductLoan = (checked) => {
        setIsExcelProductLoan(checked);
    };

    const onSwitchChangeDistrictProduct = (checked) => {
        setIsOnDistrict(checked);
    };

    const onSwitchChangeBranchLoan = (checked) => {
        setIsExcelBranchLoan(checked);
    };

    const onSwitchChangeBranchSummary = (checked) => {
        setIsExcelBranchSummary(checked);
    };

    const onSwitchChangeLoanSummary = (checked) => {
        setIsExcelLoanSummary(checked);
    };

    const onSwitchChangeDistrictLoan = (checked) => {
        setIsExcelDistrictLoan(checked);
    };

    const generateLoanReport = () => {
        let data = {
            selectedDate: branchDate,
            isExcel: isExcelLoanSummary
        };
        setLoading(true);
        generateLoanReportForDay(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setLoading(false)
        })

    };

    const generateDistrictWiseLoanReports = () => {
        let data = {
            selectedDate: districtDate,
            isExcel: isExcelDistrictLoan
        };
        setLoanLoading(true);
        generateDistrictLoanReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setLoanLoading(false)
        })

    };

    const generateDistrictLoanReports = () => {
        let data = {
            selectedDate: districtDate,
            districtName: decodeToken.districtName,
            isExcel: isExcelLoanReport
        };
        setDistrictLoading(true);
        generateDistrictReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDistrictLoading(false)
        })

    };

    const getAllBranchesByDistrict = () => {
        getDistrictBranches().then((res => {
            let data = createDistrictData(res.data);
            setDistrictData(data)
        })).catch((err) => {
            errHandler(err)
        })
    };


    const getAllBranchesByDivAId = () => {
        getDivAreaBranches().then((res => {
            let data = createDivAreaData(res.data);
            setDivAreaData(data);
        })).catch((err) => {
            errHandler(err)
        })
    }

    const generateLoanSummaryReport = () => {
        let selectedDistrictRadio = (loginPlaceId === "1" || loginPlaceId === "2") ? 1 : districtRadio;
        let selectedBranchRadio = (loginPlaceId === "1" || loginPlaceId === "2") ? 1 : branchRadio;
        let branchId = decodeToken.branchId ? decodeToken.branchId : " ";
        let data = {
            districtRadio: selectedDistrictRadio,
            districtId: selectedDistrict,
            branchRadio: selectedBranchRadio,
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            selectedDate: districtDate,
            isExcel: isExcelBranchLoan

        };
        setLoadingbranch(true);
        generateLoanSummaryReports(data).then((res) => {
            generateBlob(res.data);
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setLoadingbranch(false)
        })
    };

    const generateLoanSummaryReportforDay = () => {
        let data = {
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            selectedDate: date,
            isExcel: isExcelBranchSummary
        };
        setDateLoading(true);
        generateBranchLoanReport(data).then((res) => {
            generateBlob(res.data);
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDateLoading(false)
        })
    };


    const generateDistrictWiseProductLoanReport = () => {
        const [startDate, endDate] = selectedDates;
        let data = {
            branchId: selectedBranch,
            selectedDate: startDate,
            endDate: endDate,
            isExcel: isOnDistrict
        };
        setDateLoadingProductWise(true);
        generateDistrictLoanProductReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDateLoadingProductWise(false)
        })

    };

    const generateLoanAmountSummaryReport = async () => {
        try {
            const [startDate, endDate] = selectedDates;

            const data = {
                selectedDate: startDate,
                endDate: endDate,
                districtIdList:
                    loginPlaceId === "3"
                        ? selectedDistrictForLoanDisposeSummary
                        : [decodeToken.districtId],
                productIdList: selectedLoanProduct,
                isExcel: isExcelLoanAmtReport
            };

            setLoadingDisposeSummary(true);

            const res = await generateLoanDisposeSummaryReport(data);

            console.log("API Response:", res);

            // Generate Excel after successful API response
            await generateLoanAmountExcel(res.data, startDate, endDate);

        } catch (err) {
            errHandler(err);
        } finally {
            setLoadingDisposeSummary(false);
        }
    };


    const handleDistrictChange = (value) => {
        setSelectedDistrict(value);

        // Set the branch selection to the first branch of the selected district
        const selectedDistrictData = districtData.find((district) => district.districtId === parseInt(value));
        if (selectedDistrictData) {
            setSelectedBranch(selectedDistrictData.branchDtoList[0].id);
        }
    };

    const handleDistrictWiseProductChange = (value) => {
        setSelectedProductLoanDistrict(value);
        // Set the branch selection to the first branch of the selected district
        // const selectedDistrictData = districtData.find((district) => district.districtId === parseInt(value));
    };

    const handleDistrictChangeForLoanDisposeSummary = (value) => {
        setSelectedDistrictForLoanDisposeSummary(value);
    }

    const handleDistrictChangeForDisposeSummary = (value) => {
        setSelectedDistrictForDisposeSummary(value);
    }

    const handleBranchChange = (value) => {
        setSelectedBranch(value);
    };

    const handleBranchChangeForDisbursement = (value) => {
        setSelectedBranchForDisbursement(value);
    }

    const handleDistrictChangeForDisbursement = (value) => {
        setSelectedDistrictForDisbursement(value);
        setSelectedDivAreasForDisbursement([]);
        setSelectedBranchesForDisbursement([]);

        const filteredDivAreas = districtDivisionalBranchData
            .filter(d => d.districtId === value)
            .flatMap(d => d.divisionalAreaDtoList || []);

        setFilteredDivAreasForDisbursement(filteredDivAreas);
        setFilteredBranchesForDisbursement([]);
    };

    const handleDivAreasChangeForDisbursement = (values) => {
        if (values.includes('all')) {
            if (selectedDivAreasForDisbursement.length === filteredDivAreasForDisbursement.length) {
                setSelectedDivAreasForDisbursement([]);
                setFilteredBranchesForDisbursement([]);
                setSelectedBranchesForDisbursement([]);
            } else {
                const allDivAreaIds = filteredDivAreasForDisbursement.map(d => d.divAId);
                setSelectedDivAreasForDisbursement(allDivAreaIds);

                const allBranches = filteredDivAreasForDisbursement
                    .flatMap(d => d.branchDtoList || []);
                setFilteredBranchesForDisbursement(allBranches);
            }
        } else {
            setSelectedDivAreasForDisbursement(values);
            setSelectedBranchesForDisbursement([]);

            const filteredBranches = filteredDivAreasForDisbursement
                .filter(d => values.includes(d.divAId))
                .flatMap(d => d.branchDtoList || []);

            setFilteredBranchesForDisbursement(filteredBranches);
        }
    };

    const handleBranchesChangeForDisbursement = (values) => {
        if (values.includes('all')) {
            if (selectedBranchesForDisbursement.length === filteredBranchesForDisbursement.length) {
                setSelectedBranchesForDisbursement([]);
            } else {
                const allBranchIds = filteredBranchesForDisbursement.map(b => b.id);
                setSelectedBranchesForDisbursement(allBranchIds);
            }
        } else {
            setSelectedBranchesForDisbursement(values);
        }
    };


    const generateLoanSummaryReportforDistrictwise = () => {
        let data = {
            districtName: decodeToken.districtName,
            branchRadio: branchRadio,
            branchId: selectedBranch,
            isExcel: isExcelProductLoan
        };
        setDateLoading(true);
        generateLoanSummaryReportforDistrict(data).then((res) => {
            generateBlob(res.data);
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDateLoading(false)
        })
    };

    const handleActiveStatusChange = (value) => {
        setSelectedStatus(value);
    };

    const handleWasamChange = (value) => {
        setSelectedWasamLoanTrialBalance(value);
    };

    const handleWasamWiseProductChange = (value) => {
        console.log("Selected Wasam:", value);
        setSelectedWasamWiseProduct(value);
    };

    const handleTrailBalanceProductChange = (value) => {
        setSelectedTrailBalanceProduct(value);
    };


    const handleLoanProductChange = (value) => {
        setSelectedLoanProduct(value);
    }

    const handleLoanProductChangeForDisposeSummary = (value) => {
        setSelectedLoanProductForDisposeSummary(value);
    }

    const handledisbursementProductChange = (value) => {
        setselecteddisbursementamountProduct(value);
    };

    const handleDaDateChange = (dates) => {
        setselectedDaDates(dates);
    };

    const handleSelectChange = (values) => {
        // If "all" is selected
        if (values.includes('all')) {
            // If already all selected, remove all
            if (selecteddisbursementamountProduct.length === loanProducts.length) {
                setselecteddisbursementamountProduct([]);
            } else {
                // Otherwise select all product IDs
                const allProductIds = loanProducts.map((p) => p.productId);
                setselecteddisbursementamountProduct(allProductIds);
            }
        } else {
            setselecteddisbursementamountProduct(values);
        }
    };

    const allSelected =
        selecteddisbursementamountProduct.length === loanProducts.length &&
        loanProducts.length > 0;

    const activeStatus = [
        {
            value: 0,
            label: "Active Loans"
        },
        {
            value: 1,
            label: "Non Performing Loans"
        }
    ]


    // loan de
    const generateLoanPendingInstallments = () => {
        const [startDate, endDate] = selectedDateRange;
        let data = {
            wasamIdList: loginPlaceId === "1" ? selectedWasamLoanPendingInstallment : null,
            branchId: loginPlaceId === "1" ? branchId : locationData.branchId,
            productId: selectedWasamWiseProduct,
            selectedDate: startDate,
            activeStatus: selectedStatus,
            endDate: endDate,
            minCount: mincount,
            maxCount: maxcount
        }
        setLoanPendingInstallemnt(true);
        generateLoanPendingInstallment(data).then((res) => {
            loanPendingInstallmentExcel(res.data.data,
                res.data.branchName || "Branch", startDate ? startDate.format("YYYY-MM-DD") : "",
                endDate ? endDate.format("YYYY-MM-DD") : "",
                selectedStatus === 0 ? "Active Loans" : "Non Performing Loans",
                res.data.product,
                loginPlaceId
            );
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setLoanPendingInstallemnt(false);
        })
    };
    // loan certificate
    const generateLoanCertificates = () => {
        let data = {

            branchId: loginPlaceId === "1" ? decodeToken.branchId : selectedBranch,
            wasamId: loanCertificateWasam === "0" ? null : loanCertificateWasam,
            productIdList: selectedLoanCertificateProduct,
            // productIdList: [12,27],
            // activeStatus: selectedStatus,
            selectedDate: LoanCertificateDate



        }
        setLoanCertificate(true);
        generateLoanCertificate(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setLoanCertificate(false);
        })
    };



    const generateTrailbalaceByDateReport = () => {
        const [startDate, endDate] = selectedDaDates;
        let data = {

            branchId: decodeToken.branchId,
            productId: selectedTrailBalanceProduct,
            activeStatus: selectedStatus,
            selectedDate: startDate,
            endDate: endDate,
            // selectedDate: otherDistrictDate
        }
        setTrailBalanceByDateLoading(true);
        generateTrailBalanceByDate(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setTrailBalanceByDateLoading(false);
        })
    };










    const getLoans = () => {
        getAllLoans().then((res) => {
            let data = createDepositsProductData(res.data);
            setLoanProducts(data);
        }).catch((err) => {
            errHandler(err);
        })
    }

    const generateDisbursementAmountReport = () => {
        if (!selecteddisbursementamountProduct.length) {
            errHandler();
            return;
        }

        if (!selectedDaDates) {
            errHandler();
            return;
        }

        const [startDate, endDate] = selectedDaDates;

        let branchIdList = [];

        if (loginPlaceId === "1") {
            branchIdList = [parseInt(branchId)];
        } else if (loginPlaceId === "3") {
            if (!selectedBranchesForDisbursement || selectedBranchesForDisbursement.length === 0) {
                errHandler();
                return;
            }
            branchIdList = selectedBranchesForDisbursement.map(id => parseInt(id));
        } else if (loginPlaceId === "4") {
            if (!selectedBranchesForDisbursement || selectedBranchesForDisbursement.length === 0) {
                errHandler();
                return;
            }
            branchIdList = selectedBranchesForDisbursement.map(id => parseInt(id));
        } else if (loginPlaceId === "2") {
            if (!selectedBranchesForDisbursement || selectedBranchesForDisbursement.length === 0) {
                errHandler();
                return;
            }
            branchIdList = selectedBranchesForDisbursement.map(id => parseInt(id));
        }

        if (!branchIdList.length) {
            errHandler();
            return;
        }

        const data = {
            selectedDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD"),
            branchIdList: branchIdList,
            productIdList: selecteddisbursementamountProduct,
        };

        console.log("Request Data:", data);

        setproductDisbursementLoading(true);

        generateLoanDisbursementSummaryReport(data)
            .then((res) => {
                console.log("API Response:", res);

                const reportData = res?.data || res;
                if (!reportData) throw new Error("No data from server");

                const dataArray = Array.isArray(reportData) ? reportData : (reportData.data || []);

                console.log("Data Array:", dataArray);

                if (!dataArray || dataArray.length === 0) {
                    errHandler();
                    return;
                }

                let selectedBranches = [];

                if (loginPlaceId === "1") {
                    selectedBranches = branchData && branchData.length > 0
                        ? branchData.filter(b => b.id === parseInt(branchId))
                        : [{ id: branchId, branchName: decodeToken.branchName || "Current Branch" }];
                } else if (loginPlaceId === "2" || loginPlaceId === "3" || loginPlaceId === "4") {
                    selectedBranches = filteredBranchesForDisbursement
                        .filter(b => branchIdList.includes(b.id));
                }

                console.log("Selected Branches:", selectedBranches);

                if (!selectedBranches || selectedBranches.length === 0) {
                    selectedBranches = branchIdList.map(id => ({
                        id: id,
                        branchName: "Selected Branch",
                        branchCode: "N/A"
                    }));
                }

                generateLoanDisbursementSummaryExcel(
                    dataArray,
                    selectedBranches,
                    startDate.format("YYYY-MM-DD"),
                    endDate.format("YYYY-MM-DD"),
                    loginPlaceId
                );
            })
            .catch((err) => {
                console.error("Error:", err);
                errHandler();
            })
            .finally(() => setproductDisbursementLoading(false));
    };





    const getAllDistrictDivisionalBranch = () => {
        getDistrictDivisionalBranchDetails().then((res) => {
            setDistrictDivisionalBranchData(res.data);
        }).catch((err) => {
            errHandler(err);
        })
    };

    useEffect(() => {
        //getAllDistricts();
        //
        getAllDistrictDivisionalBranch();
        getLoans();
        if (loginPlaceId !== "2") {
            getAllBranchesByDistrict();
        }
        if (loginPlaceId === "4") {
            getAllBranchesbyDistrict();
        }
        if (loginPlaceId === "1") {
            getAllWasam();
        } else if (loginPlaceId === "2") {
            getAllBranchesByDivAId();
            setSelectedDivisionalArea(decodeToken.divAId)
        }
    }, []);
    // const buttonHoverStyles = {
    //     backgroundColor: '#0056b3',
    //     borderColor: '#004085',
    // };

    useEffect(() => {
        if (loginPlaceId === "4" && districtName && districtDivisionalBranchData.length > 0) {
            const districtData = districtDivisionalBranchData.find(d => d.districtName === districtName);
            if (districtData) {
                setFilteredDivAreasForDisbursement(districtData.divisionalAreaDtoList || []);
            }
        }

        if (loginPlaceId === "2" && selectedDivisionalArea && divAreaData.length > 0) {
            const divArea = divAreaData.find(d => d.divAId === parseInt(selectedDivisionalArea));
            if (divArea) {
                setFilteredBranchesForDisbursement(divArea.branchDtoList || []);
            }
        }
    }, [loginPlaceId, districtName, districtDivisionalBranchData, selectedDivisionalArea, divAreaData]);

    return (
        <>
            <div>
                <h3>Loan</h3>
            </div>
            <Collapse className="collapse-report">
                <PermissionPanel
                    permission="loanInquirySummary"
                    placeIds={["1", "2", "3", "4"]}
                    header="Loan Inquiry Summary"
                    key="loanPaymentHistory"
                    className={`collapse-panel `}>

                    <LoanPaymentHistory
                        loginPlaceId={loginPlaceId}
                        loanNo={loanNo}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanInquirySummary"
                    placeIds={["1", "2", "3", "4"]}
                    header="Customer Loan Details Report"
                    key="customerLoanDetailsReport"
                    className={`collapse-panel`}
                >
                    <CustomerLoanDetails
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanInquirySummary"
                    placeIds={["1", "2", "3", "4"]}
                    header="Wasama-wise Customer Loan Details Report"
                    key="wasamaCustomerLoanDetailsReport"
                    className="collapse-panel"
                >
                    <WasamaCustomerLoanDetails
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalAreaId={divisionalID}
                        branchId={branchId}
                        wasamData={wasamData}
                        loanProducts={loanProducts}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="productWiseLoanSummary"
                    placeIds={["1", "3", "2"]}
                    header="Branch Loan Summary Report Product Wise"
                    key="productWiseLoanSummary"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "3" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "3" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="District Selection">
                                                <Radio.Group onChange={handleDistrictRadioChange} value={districtRadio}>
                                                    <Radio value={0}>All District</Radio>
                                                    <Radio value={1}>Choose District</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                {loginPlaceId === "3" && districtRadio === 1 && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <Select value={selectedDistrict} onChange={handleDistrictChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select District --</Option>
                                                    {districtData.map((district) => (
                                                        <Option key={district.districtId} value={district.districtId}>
                                                            {district.districtName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        {loginPlaceId === "3" && (selectedDistrict || selectedDivisionalArea) && (
                                            <Form.Item label="Branch Selection">
                                                <Radio.Group onChange={onRadioChange} value={branchRadio}>
                                                    <Radio value={0}>All Branches</Radio>
                                                    <Radio value={1}>Choose Branch</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        )}
                                    </Col>
                                </Row>
                                {loginPlaceId === "3" && branchRadio === 1 && selectedDistrict && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {districtData.find((district) => district.districtId === parseInt(selectedDistrict)).branchDtoList.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                {loginPlaceId === "2" && divAreaData.length > 0 && selectedDivisionalArea && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {divAreaData.find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea)).branchDtoList.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeBranchLoan} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateLoanSummaryReport} disabled={loadingbranch} className="generate-btn">
                                                {loadingbranch ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanSummaryReportPDF"
                    placeIds={["1", "3", "2"]}
                    header="Branch Loan Summary Report for a Day"
                    key="loanSummaryReportPDF"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "3" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "3" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <Select value={selectedDistrict} onChange={handleDistrictChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select District --</Option>
                                                    {districtData.map((district) => (
                                                        <Option key={district.districtId} value={district.districtId}>
                                                            {district.districtName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                {loginPlaceId === "3" && selectedDistrict && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {districtData.find((district) => district.districtId === parseInt(selectedDistrict)).branchDtoList.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                {loginPlaceId === "2" && divAreaData.length > 0 && selectedDivisionalArea && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {divAreaData.find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea)).branchDtoList.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {/*<Row gutter={[16, 16]}>*/}
                                {/*    <Col span={24}>*/}
                                {/*        <Form.Item label="Generate Excel Sheet">*/}
                                {/*            <Switch defaultChecked={false} onChange={onSwitchChangeBranchSummary} />*/}
                                {/*        </Form.Item>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateLoanSummaryReportforDay} disabled={!date || dateLoading} className="generate-btn">
                                                {dateLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanSummaryForDay"
                    placeIds={["3"]}
                    header="Loan Summary for a Day"
                    key="loanSummaryForDay"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <LoanSummaryForDay
                        loginPlaceId={loginPlaceId}
                        products={loanProducts}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        branchId={branchId}
                        divisionalAreaId={divisionalID}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="districtWiseLoanReport"
                    placeIds={["3"]}
                    header="District Wise Loan Report"
                    key="districtWiseLoanReport"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}
                >
                    <DistrictLoanWiseReport
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        branchData={branchData}
                        districtName={districtName}
                        branchId={branchId}
                        divisionalAreaId={divisionalID}
                    />
                </PermissionPanel>


                <PermissionPanel
                    permission="districtLoanReport"
                    placeIds={["4"]}
                    header="District Loan Report"
                    key="districtLoanReport"
                    className={`collapse-panel ${loginPlaceId === "4" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setDistrictDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeLoan} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24} align="right">
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateDistrictLoanReports} disabled={!districtDate || districtLoading}>
                                                {districtLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>


                <PermissionPanel
                    permission="productAndDistrictWiseLoanReport"
                    placeIds={["4"]}
                    header="Product Wise District Wise Loan Report"
                    key="productAndDistrictWiseLoanReport"
                    className={`collapse-panel ${loginPlaceId === "4" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Col span={24}>

                                    <Form.Item label="Select Branch">
                                        <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                            <Option value="">-- Select --</Option>
                                            {branchData.length > 0 &&
                                                branchData.map((branch) => (
                                                    <Option key={branch.id} value={branch.id}>
                                                        {branch.branchName}
                                                    </Option>
                                                ))}
                                        </Select>
                                    </Form.Item>

                                </Col>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeProductLoan} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24} className="generate-button" style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button
                                                onClick={generateLoanSummaryReportforDistrictwise}
                                                disabled={dateLoading}
                                                className="generate-btn">
                                                {dateLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanTrailBalance"
                    placeIds={["1", "2", "4", "3"]}
                    header="Loan Trail Balance"
                    key="loanTrailBalance"
                    className={`collapse-panel`}>
                    <LoanTrailBalance
                        loginPlaceId={loginPlaceId}
                        products={loanProducts}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        branchId={branchId}
                        divitionalAreaId={divisionalID}
                        wasamData={wasamData}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanSummaryExcel"
                    placeIds={["1", "2", "3", "4"]}
                    header="Loan Summary Excel"
                    key="loanSummaryExcel"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" || loginPlaceId === "2" || loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <LoanSummary
                        loginPlaceId={loginPlaceId}
                        products={loanProducts}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        branchId={branchId}
                        divisionalAreaId={divisionalID}
                    />
                </PermissionPanel>


                <PermissionPanel
                    permission="districtWiseProductLoanReport"
                    placeIds={["3"]}
                    header="District Wise Product Loan Report"
                    key="districtWiseProductLoanReport"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "3" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <Select value={selectedProductLoanDistrict} onChange={handleDistrictWiseProductChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select District --</Option>
                                                    {districtData.map((district) => (
                                                        <Option key={district.districtId} value={district.districtId}>
                                                            {district.districtName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Branch">
                                            <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select --</Option>
                                                {branchData.length > 0 &&
                                                    branchData.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Date Range">
                                            <RangePicker onChange={handleDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeDistrictProduct} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateDistrictWiseProductLoanReport} disabled={dateLoadingProductWise} className="generate-btn">
                                                {dateLoadingProductWise ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="amountWiseLoanDisposeSummary"
                    placeIds={["3", "4"]}
                    header="Loan Amount Wise Dispose Summary"
                    key="amountWiseLoanDisposeSummary"
                    className={`collapse-panel ${(loginPlaceId === "3" || loginPlaceId === "4") ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "3" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <Select mode="multiple" value={selectedDistrictForLoanDisposeSummary} onChange={(values) => {
                                                    if (values.includes("ALL")) {
                                                        // Select all districts when "ALL" is selected
                                                        setSelectedDistrictForLoanDisposeSummary(districtData.map(d => d.districtId));
                                                    } else {
                                                        setSelectedDistrictForLoanDisposeSummary(values);
                                                    }
                                                }} style={{ width: '100%' }}>
                                                    <Option key="0" value="ALL">ALL DISTRICTS</Option>
                                                    {districtData.map((district) => (
                                                        <Option key={district.districtId} value={district.districtId}>
                                                            {district.districtName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select mode="multiple" value={selectedLoanProduct}
                                                onChange={(values) => {
                                                    if (values.includes("0")) {
                                                        // Select all products when "ALL PRODUCTS" is selected
                                                        setSelectedLoanProduct(loanProducts.map(p => p.productId));
                                                    } else {
                                                        setSelectedLoanProduct(values);
                                                    }
                                                }}
                                                style={{ width: '100%' }}>
                                                <Option value="">-- Select Product--</Option>
                                                <Option key="0" value="0">ALL PRODUCTS</Option>
                                                {loanProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}
                                                        <Tooltip title={`${product.legCode}-${product.legName}`} placement="left">
                                                            <span>{product.legCode}-{product.legName}</span>
                                                        </Tooltip>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Date Range">
                                            <RangePicker onChange={handleDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button onClick={generateLoanAmountSummaryReport} disabled={loadingDisposeSummary} className="generate-btn">
                                                {loadingDisposeSummary ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                {/*<PermissionPanel*/}
                {/*    permission="districtWiseDisposeSummary"*/}
                {/*    placeIds={["3", "4"]}*/}
                {/*    header="District Wise Dispose Summary"*/}
                {/*    key="districtWiseDisposeSummary"*/}
                {/*    className={`collapse-panel ${(loginPlaceId === "3" || loginPlaceId === "4") ? '' : 'hidden'}`}>*/}
                {/*    <div className="panel-container">*/}
                {/*        <Card hoverable className="inner-card">*/}
                {/*            <Form layout="vertical">*/}
                {/*                {loginPlaceId === "3" && (*/}
                {/*                    <Row gutter={[16, 16]}>*/}
                {/*                        <Col span={24}>*/}
                {/*                            <Form.Item label="Select District">*/}
                {/*                                <Select value={selectedDistrictForDisposeSummary} onChange={handleDistrictChangeForDisposeSummary} style={{ width: '100%' }}>*/}
                {/*                                    <Option value="">-- Select District --</Option>*/}
                {/*                                    <Option key="0" value="ALL">ALL DISTRICTS</Option>*/}
                {/*                                    {districtData.map((district) => (*/}
                {/*                                        <Option key={district.districtId} value={district.districtName}>*/}
                {/*                                            {district.districtName}*/}
                {/*                                        </Option>*/}
                {/*                                    ))}*/}
                {/*                                </Select>*/}
                {/*                            </Form.Item>*/}
                {/*                        </Col>*/}
                {/*                    </Row>*/}
                {/*                )}*/}
                {/*                <Row gutter={[16, 16]}>*/}
                {/*                    <Col span={24}>*/}
                {/*                        <Form.Item label="Product">*/}
                {/*                            <Select value={selectedLoanProductForDisposeSummary} onChange={handleLoanProductChangeForDisposeSummary} style={{ width: '100%' }}>*/}
                {/*                                <Option value="">-- Select Product--</Option>*/}
                {/*                                <Option key="0" value="0">ALL PRODUCTS</Option>*/}
                {/*                                {loanProducts.map((product) => (*/}
                {/*                                    <Option key={product.productId} value={product.productId}>*/}
                {/*                                        {product.productCode}-{product.productName}*/}
                {/*                                        <Tooltip title={`${product.legCode}-${product.legName}`} placement="left">*/}
                {/*                                            <span>{product.legCode}-{product.legName}</span>*/}
                {/*                                        </Tooltip>*/}
                {/*                                    </Option>*/}
                {/*                                ))}*/}
                {/*                            </Select>*/}
                {/*                        </Form.Item>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*                <Row gutter={[16, 16]}>*/}
                {/*                    <Col span={24}>*/}
                {/*                        <Form.Item label="Select Date Range">*/}
                {/*                            <RangePicker onChange={handleDateChangeForDisposeSummary} style={{ width: '100%' }} />*/}
                {/*                        </Form.Item>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*                <Row gutter={[16, 16]}>*/}
                {/*                    <Col span={24}>*/}
                {/*                        <Form.Item label="Generate Excel Sheet">*/}
                {/*                            <Switch defaultChecked={false} onChange={onSwitchChangeDisposeSummary} />*/}
                {/*                        </Form.Item>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*                <Row gutter={[16, 16]}>*/}
                {/*                    <Col span={24}>*/}
                {/*                        <Form.Item className="generate-btn-outline">*/}
                {/*                            <Button onClick={generateDisposeSummaryReport} disabled={loadingSummaryReport} className="generate-btn">*/}
                {/*                                {loadingSummaryReport ? <Spin /> : 'Generate Report'}*/}
                {/*                            </Button>*/}
                {/*                        </Form.Item>*/}
                {/*                    </Col>*/}
                {/*                </Row>*/}
                {/*            </Form>*/}
                {/*        </Card>*/}
                {/*    </div>*/}
                {/*</PermissionPanel>*/}

                <PermissionPanel
                    permission="districtWiseDisposeSummary"
                    placeIds={["1", "2", "3", "4"]}
                    header="District Wise Dispose Summary"
                    key="districtWiseDisposeSummary"
                    className={`collapse-panel`}
                >
                    <DistrictWiseDisposeSummary
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        loanProducts={loanProducts}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanApplicationProcess"
                    placeIds={["1", "2", "3", "4"]}
                    header="Loan Application Progress Report"
                    key="loanApplicationProcess"
                    className={`collapse-panel`}
                >
                    <LoanApplicationProcess
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        loanProducts={loanProducts}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanProcessReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Loan Progress Report"
                    key="loanProgressReport"
                    className="collapse-panel"
                >
                    <LoanProgressReport
                        loginPlaceId={loginPlaceId}
                        loanProducts={loanProducts}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divisionalID}
                        branchId={branchId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="loanDisbursementAmount"
                    placeIds={["1", "4", "2", "3"]}
                    header="Loan Disbursement Amount"
                    key="loanDisbursementAmount"
                    className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "3" && (
                                    <>
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <Form.Item label="Select District">
                                                    <Select
                                                        value={selectedDistrictForDisbursement}
                                                        onChange={handleDistrictChangeForDisbursement}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <Option value="">-- Select District --</Option>
                                                        {districtDivisionalBranchData.map((district) => (
                                                            <Option key={district.districtId} value={district.districtId}>
                                                                {district.districtName}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        {selectedDistrictForDisbursement && filteredDivAreasForDisbursement.length > 0 && (
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <Form.Item label="Select Divisional Areas">
                                                        <Select
                                                            mode="multiple"
                                                            value={selectedDivAreasForDisbursement}
                                                            onChange={handleDivAreasChangeForDisbursement}
                                                            style={{ width: '100%' }}
                                                            placeholder="Select divisional areas"
                                                            maxTagCount="responsive"
                                                        >
                                                            <Option key="all" value="all">
                                                                {selectedDivAreasForDisbursement.length === filteredDivAreasForDisbursement.length ? 'Deselect All' : 'Select All'}
                                                            </Option>
                                                            {filteredDivAreasForDisbursement.map((divArea) => (
                                                                <Option key={divArea.divAId} value={divArea.divAId}>
                                                                    {divArea.divAIdName}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )}

                                        {selectedDivAreasForDisbursement.length > 0 && filteredBranchesForDisbursement.length > 0 && (
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <Form.Item label="Select Branches">
                                                        <Select
                                                            mode="multiple"
                                                            value={selectedBranchesForDisbursement}
                                                            onChange={handleBranchesChangeForDisbursement}
                                                            style={{ width: '100%' }}
                                                            placeholder="Select branches"
                                                            maxTagCount="responsive"
                                                        >
                                                            <Option key="all" value="all">
                                                                {selectedBranchesForDisbursement.length === filteredBranchesForDisbursement.length ? 'Deselect All' : 'Select All'}
                                                            </Option>
                                                            {filteredBranchesForDisbursement.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}

                                {loginPlaceId === "4" && (
                                    <>
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <Form.Item label="Select Divisional Areas">
                                                    <Select
                                                        mode="multiple"
                                                        value={selectedDivAreasForDisbursement}
                                                        onChange={handleDivAreasChangeForDisbursement}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select divisional areas"
                                                        maxTagCount="responsive"
                                                    >
                                                        <Option key="all" value="all">
                                                            {selectedDivAreasForDisbursement.length === filteredDivAreasForDisbursement.length
                                                                ? 'Deselect All'
                                                                : 'Select All'}
                                                        </Option>
                                                        {filteredDivAreasForDisbursement.map((divArea) => (
                                                            <Option key={divArea.divAId} value={divArea.divAId}>
                                                                {divArea.divAIdName}
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                        {selectedDivAreasForDisbursement.length > 0 && filteredBranchesForDisbursement.length > 0 && (
                                            <Row gutter={[16, 16]}>
                                                <Col span={24}>
                                                    <Form.Item label="Select Branches">
                                                        <Select
                                                            mode="multiple"
                                                            value={selectedBranchesForDisbursement}
                                                            onChange={handleBranchesChangeForDisbursement}
                                                            style={{ width: '100%' }}
                                                            placeholder="Select branches"
                                                            maxTagCount="responsive"
                                                        >
                                                            <Option key="all" value="all">
                                                                {selectedBranchesForDisbursement.length === filteredBranchesForDisbursement.length
                                                                    ? 'Deselect All'
                                                                    : 'Select All'}
                                                            </Option>
                                                            {filteredBranchesForDisbursement.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )}
                                    </>
                                )}

                                {loginPlaceId === "2" && filteredBranchesForDisbursement.length > 0 && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branches">
                                                <Select
                                                    mode="multiple"
                                                    value={selectedBranchesForDisbursement}
                                                    onChange={handleBranchesChangeForDisbursement}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select branches"
                                                    maxTagCount="responsive"
                                                >
                                                    <Option key="all" value="all">
                                                        {selectedBranchesForDisbursement.length === filteredBranchesForDisbursement.length ? 'Deselect All' : 'Select All'}
                                                    </Option>
                                                    {filteredBranchesForDisbursement.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select
                                                mode="multiple"
                                                placeholder="-- Select Product --"
                                                value={selecteddisbursementamountProduct}
                                                onChange={handleSelectChange}
                                                style={{ width: '100%' }}
                                                optionLabelProp="label"
                                            >
                                                {/* Select All option */}
                                                <Option key="all" value="all" label="Select All">
                                                    {allSelected ? 'Deselect All' : 'Select All'}
                                                </Option>

                                                {/* Product options */}
                                                {loanProducts.map((product) => (
                                                    <Option
                                                        key={product.productId}
                                                        value={product.productId}
                                                        label={`${product.productCode}-${product.productName}`}
                                                    >
                                                        {product.productCode}-{product.productName}
                                                        <Tooltip
                                                            title={`${product.legCode}-${product.legName}`}
                                                            placement="left"
                                                        >
                                                            <span style={{ marginLeft: 8, color: '#999' }}>
                                                                ({product.legCode}-{product.legName})
                                                            </span>
                                                        </Tooltip>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Select Date Range">
                                            <RangePicker onChange={handleDaDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button
                                                onClick={generateDisbursementAmountReport}
                                                disabled={productDisbursementLoading || !selectedDaDates}
                                                className="generate-btn"
                                            >
                                                {productDisbursementLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanPendingInstallment"
                    placeIds={["1", "4", "2", "3"]}
                    header="Loan Pending Installment"
                    key="loanPendingInstallment"
                    className={`collapse-panel `}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">

                                {/* Removed Loan Type Select Box */}
                                <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divisionalID} onChange={setLocationData} />
                                {loginPlaceId === "1" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select
                                                    mode="multiple" //Enable multiple selections
                                                    value={selectedWasamLoanPendingInstallment} // Current selected Wasams
                                                    onChange={(value) => {
                                                        if (value.includes("0")) { // If "All Wasam" is selected
                                                            const allWasamIds = wasamData.map((wasam) => wasam.wastId); // Get all Wasam IDs
                                                            setSelectedWasamLoanPendingInstallment(allWasamIds); // Automatically select all Wasams
                                                        } else {
                                                            setSelectedWasamLoanPendingInstallment(value); // Otherwise, set the selected Wasams
                                                        }
                                                    }}
                                                    style={{ width: '100%' }}
                                                    maxTagCount={selectedWasamLoanPendingInstallment.includes("0") ? 0 : 1} // Show one item in text box unless "All Wasam" is selected
                                                    tagRender={({ label, value, closable, onClose }) => {
                                                        if (selectedWasamLoanPendingInstallment.includes("0")) {
                                                            return <span>All Wasam Selected</span>; // Custom message when "All Wasam" is selected
                                                        } else {
                                                            return <span>{label}</span>; // Display individual Wasam names
                                                        }
                                                    }}
                                                >
                                                    <Option key="0" value="0">All Wasam</Option> {/* Option to select all */}
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            {wasam.wasName}-{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}

                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Active">
                                            <Select
                                                style={{ width: '100%' }}
                                                onChange={handleActiveStatusChange}
                                                options={activeStatus}>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>


                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select
                                                value={selectedWasamWiseProduct}  // This should store a single product ID
                                                onChange={(value) => {
                                                    if (value === "") {  // Handle "All Product" if needed
                                                        setSelectedWasamWiseProduct("");
                                                    } else {
                                                        setSelectedWasamWiseProduct(value);  // Only store single product ID
                                                    }
                                                }}
                                                style={{ width: '100%' }}
                                                maxTagCount={1} // Show one item
                                            >
                                                <Option value="">All Product</Option> {/* Handle "All Product" option */}
                                                {loanProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}
                                                        <Tooltip title={`${product.legCode}-${product.legName}`} placement="left">
                                                            <span>{product.legCode}-{product.legName}</span>
                                                        </Tooltip>
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Checkbox
                                            checked={showRangePicker}
                                            onChange={handleRangeDateCheckboxChange}
                                        >
                                            By Date Range
                                        </Checkbox>
                                    </Col>

                                    {showRangePicker && (
                                        <Col span={24}>
                                            <Form.Item label="Select Date Range">
                                                <RangePicker onChange={handleRangeDateChange} style={{ width: '100%' }} />
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>

                                {/* Checkbox for Min/Max */}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Checkbox value={maxcount} checked={ShowMinMax} onChange={handleMinMaxCheckboxChange}>
                                            By Number Of Outstanding
                                        </Checkbox>
                                    </Col>
                                </Row>
                                {ShowMinMax && (
                                    <>
                                        {/* New Min Name Field */}
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <Form.Item label="Min">
                                                    <input
                                                        type="number"
                                                        value={mincount}
                                                        onChange={handleMinChange}
                                                        min={0} // Minimum value allowed

                                                        placeholder="Enter minimum value"
                                                        style={{ width: '100%' }} />

                                                </Form.Item>

                                            </Col>
                                        </Row>
                                        {/* New Max Name Field */}
                                        <Row gutter={[16, 16]}>
                                            <Col span={24}>
                                                <Form.Item label="Max">
                                                    <input
                                                        type="number"
                                                        value={maxcount}
                                                        onChange={handleMaxChange}
                                                        max={500} // Maximum value allowed
                                                        placeholder="Enter maximum value"
                                                        style={{ width: '100%' }}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button
                                                onClick={generateLoanPendingInstallments}
                                                disabled={LoanPendingInstallment}
                                                className="generate-btn">
                                                {LoanPendingInstallment ? <Spin /> : 'Generate Report'}
                                            </Button>

                                        </Form.Item>
                                    </Col>
                                </Row>





                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanCertificate"
                    placeIds={["1"]}
                    header="Loan Certificate"
                    key="loanCertificate"
                    className={`collapse-panel ${loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                {loginPlaceId === "4" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}

                                {loginPlaceId === "2" && divAreaData.length > 0 && selectedDivisionalArea && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {divAreaData
                                                        .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                        .branchDtoList.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}

                                {loginPlaceId === "1" && (
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <Form.Item label="Wasam">
                                                <Select value={loanCertificateWasam} onChange={handleWasamChangeLoanCertificate} style={{ width: '100%' }}>
                                                    <Option key="0" value="0">All Wasam</Option>
                                                    {wasamData.map((wasam) => (
                                                        <Option key={wasam.wastId} value={wasam.wastId}>
                                                            {wasam.wasName}-{wasam.wasName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                )}

                                <Col span={24}>
                                    <Form.Item label="Select Date">
                                        <DatePicker onChange={(date) => setLoanCertificateDate(date)} disabledDate={disabledDatesBeforeYear} style={{ width: '100%' }} />
                                    </Form.Item>
                                </Col>

                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item label="Product">
                                            <Select
                                                mode="multiple"
                                                value={selectedLoanCertificateProduct}
                                                onChange={(values) => {
                                                    if (values.includes("ALL")) {
                                                        setSelectedLoanCertificateProduct(
                                                            loanProducts.map((product) => product.productId)
                                                        );
                                                    } else {
                                                        setSelectedLoanCertificateProduct(values);
                                                    }
                                                }}
                                                style={{ width: "100%" }}
                                                maxTagCount="responsive"
                                                placeholder="Select Products"
                                            >
                                                <Option key="ALL" value="ALL">
                                                    All Products
                                                </Option>

                                                {loanProducts.map((product) => (
                                                    <Option key={product.productId} value={product.productId}>
                                                        {product.productCode}-{product.productName}

                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={[16, 16]}>
                                    <Col span={24}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button
                                                onClick={generateLoanCertificates}
                                                disabled={LoanCertificate}
                                                className="generate-btn">
                                                {LoanCertificate ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

            </Collapse>
            <CustomFooter />
        </>
    )
};
export default Loan;